// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2lK11","inputWrap":"Table_inputWrap__2BND2","col":"Table_col__2be6O","bmiTooltip":"Table_bmiTooltip__1Gy_m"};